/**
 * SnapshotPayload created by karora on 29/03/17.
 */
import {Component, Input, OnInit} from '@angular/core';

import {AppComponent} from '../app.component';

// {
//   "snapshot":[
//     {
//       "hubid":196,
//       "last_seen":"2019-02-10T23:36:09.227727Z",
//       "setpoint":21.2,
//       "temperature":19.99,
//       "heating":0,
//       "holiday":false,
//       "meterread":false,
//       "battery_mv":0,
//       "boiler":false,
//       "age":0
//     }
//   ]
// }
class snapShot {
  age: number;
  boiler: boolean;
  heating: number;
  holiday: boolean;
  hubid: number;
  last_seen: number;
  meterread: boolean;
  setpoint: number;
  temperature: number;
  battery_mv: number;
}

@Component({
  selector: 'snapshot-payload',
  template: `
    <div id="snapshot" *ngIf="payload && payload != '[]'">
      <span class="snapshot">Set: {{processedSnapshot.setpoint}}</span>
      <span class="snapshot">Temp: {{processedSnapshot.temperature}}</span>
      <span class="snapshot">Heating: {{processedSnapshot.heating | heatingState}}</span>
      <span class="snapshot">Battery: {{processedSnapshot.battery_mv}}</span>
    </div>`,
  styles: [
    `.snapshot { padding: 0.1em 1em; }`
  ],
})

export class SnapshotPayloadComponent implements OnInit {
  @Input() payload: any;
  processedSnapshot: snapShot;
  errorMessage: string;

  constructor() { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.processSnapshot();
  }

  processSnapshot(): void {
    this.processedSnapshot = <snapShot>this.payload[0];
  }
}
